<div class="card card-flush h-xl-100">
  <div class="card-body pt-5">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>Notification Group List</nz-page-header-title>
      <nz-page-header-subtitle>Manage your notifications here</nz-page-header-subtitle>
      <nz-page-header-extra>
        <button nz-button nzType="default" (click)="showBroadcastModal()" style="margin-right: 8px;">
          <i nz-icon nzType="notification" nzTheme="outline"></i> Send Push Notification
        </button>
        @if (permission.Add) {
          <button nz-button nzType="primary" (click)="showModal()">
            Add New
          </button>
        }
      </nz-page-header-extra>
    </nz-page-header>
    <nz-divider></nz-divider>

    <div style="padding: 8px; float: right">
      <input type="text" style="width: 250px; margin-right: 8px" nz-input placeholder="Search notification type"
        [(ngModel)]="searchValue" (keydown)="onKeydown($event)" (ngModelChange)="ValidateText()" />

      <button nz-button nzSize="small" nzType="primary" (click)="search()" style="margin-right: 8px">
        Search
      </button>

      <button nz-button nzSize="small" (click)="reset()">Reset</button>
      <button nz-button nzSize="small" (click)="export()">
        <i nz-icon nzType="export" nzTheme="outline"></i> Export
      </button>
    </div>

    <nz-table [nzPageSize]="100" style="width: 100%" nzBordered [nzScroll]="{ x: '1200px', y: '515px' }" nzSize="small"
      #basicTable [nzData]="this.NotificationGroupList" [nzLoading]="isTableLoading">
      <thead>
        <tr>
          <th nzWidth="50px" nzLeft>S.No</th>
          <th nzWidth="130px">Notification Type</th>
          <th nzWidth="100px">Report Name</th>
          <th nzWidth="100px">Trigger Type</th>
          <th nzWidth="100px">User Type</th>
          <th nzWidth="160px">Name</th>
          <th nzWidth="100px">Email</th>
          <th nzWidth="100px">Mobile</th>
          <th nzWidth="110px">WhatsApp Notification</th>
          <th nzWidth="100px">Enabled To Email</th>
          <th nzWidth="100px">Enabled CC Email</th>
          <th nzWidth="100px">Enabled BCC Email</th>
          <th nzWidth="100px" nzRight style="text-align: center">Action</th>
        </tr>
      </thead>
      <tbody>
        @for (data of NotificationGroupList; track data; let i = $index) {
          <tr>
            <td nzLeft>{{ data.SerialNumber }}</td>
            <td>{{ data.NotificationType }}</td>
            <td>{{ data.ReportName }}</td>
            <td>
              @if (isArray(data.TriggerType)) {
                @for (trigger of data.TriggerType; track trigger) {
                  <nz-tag [nzColor]="getTriggerTypeColor(trigger)"
                    style="margin-right: 4px;">
                    {{ trigger }}
                  </nz-tag>
                }
              } @else {
                <nz-tag [nzColor]="getTriggerTypeColor(data.TriggerType?.toString() || 'Event')">
                  {{ data.TriggerType || 'Event' }}
                </nz-tag>
              }
            </td>
            <td>{{ data.UserType }}</td>
            <td>{{ data.Name }}</td>
            <td>{{ data.Email }}</td>
            <td>{{ data.MobileNumber }}</td>
            <td>{{ data.IsWhatsAppNotificationEnabled ? "Yes" : "No" }}</td>
            <td>{{ data.EnableToEmail ? "Yes" : "No" }}</td>
            <td>{{ data.EnableCcemail ? "Yes" : "No" }}</td>
            <td>{{ data.EnableBccemail ? "Yes" : "No" }}</td>
            <td nzRight style="text-align: center">
              <button nz-button nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" nzSize="small" nzType="default">
                <i nz-icon nzType="more" nzTheme="outline"></i>
                Actions
                <i nz-icon nzType="down"></i>
              </button>
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu nzSelectable>
                  @if (permission.View) {
                    <li nz-menu-item (click)="handleAction('view', data)">
                      <i nz-icon nzType="eye" nzTheme="outline"></i>
                      View
                    </li>
                  }
                  @if (permission.Edit) {
                    <li nz-menu-item (click)="handleAction('edit', data)">
                      <i nz-icon nzType="edit" nzTheme="outline"></i>
                      Edit
                    </li>
                  }
                  <li nz-menu-divider></li>
                  @if (permission.Delete) {
                    <li nz-menu-item (click)="handleAction('delete', data)" class="text-danger">
                      <i nz-icon nzType="delete" nzTheme="outline"></i>
                      Delete
                    </li>
                  }
                </ul>
              </nz-dropdown-menu>
            </td>
          </tr>
        }
      </tbody>
    </nz-table>

    <nz-modal [(nzVisible)]="isVisible" [nzStyle]="{ top: '20px' }" nzWidth="700px" [nzTitle]="modalTitle"
      [nzContent]="modalContent" [nzFooter]="modalFooter" (nzOnCancel)="handleCancel()">
      <ng-template #modalTitle>{{ NotificationTitle }}</ng-template>
      <ng-template #modalContent>
        <form nz-form [formGroup]="validateForm">
          <!-- ===================================================== -->
          <!-- 8-LEVEL HIERARCHICAL DROPDOWN SEQUENCE -->
          <!-- ===================================================== -->

          <!-- Level 1: Category Type (Filter only, not saved to database) -->
          <nz-form-item>
            <nz-form-label [nzSpan]="8">Category Filter</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <nz-select [(ngModel)]="SelectedCategoryType" name="categoryFilter" nzPlaceHolder="Filter by Category"
                (ngModelChange)="onCategoryTypeChange($event)" nzAllowClear [ngModelOptions]="{standalone: true}">
                @for (category of cachedCategoryTypes; track category) {
                  <nz-option [nzValue]="category.value"
                  [nzLabel]="category.label"></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <!-- Level 2: Notification Type (Cascading based on Category selection) -->
          @if (SelectedCategoryType) {
            <nz-form-item>
              <nz-form-label [nzSpan]="8" nzRequired>Notification Type</nz-form-label>
              <nz-form-control [nzSpan]="14" nzValidateStatus="success">
                <nz-select formControlName="NotificationType" name="notificationType" nzShowSearch
                  nzPlaceHolder="Select Notification Type" (ngModelChange)="onNotificationTypeChange($event)">
                  @for (notification of cachedNotificationTypes; track notification) {
                    <nz-option [nzValue]="notification.value"
                    [nzLabel]="notification.label"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          }

          <!-- Level 3: Report Type (Only visible when Notification Type = "Reports") -->
          @if (shouldShowReportTypeDropdown()) {
            <nz-form-item>
              <nz-form-label [nzSpan]="8" nzRequired>Report Type</nz-form-label>
              <nz-form-control [nzSpan]="14" nzValidateStatus="success">
                <nz-select formControlName="ReportType" name="reportType" nzShowSearch nzPlaceHolder="Select Report Type"
                  (ngModelChange)="onReportTypeChange($event)">
                  @for (reportType of cachedReportTypes; track reportType) {
                    <nz-option [nzValue]="reportType.value"
                    [nzLabel]="reportType.label"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          }
          <!-- Level 4: Trigger Type (Filtered based on configuration capabilities) -->
          @if (SelectedConfiguration) {
            <nz-form-item>
              <nz-form-label [nzSpan]="8" nzRequired>Trigger Type</nz-form-label>
              <nz-form-control [nzSpan]="14" nzValidateStatus="success">
                <nz-select formControlName="TriggerType" name="triggerType" nzMode="multiple" nzShowSearch
                  nzPlaceHolder="Select Trigger Type" (ngModelChange)="onTriggerTypeChange($event)">
                  @for (trigger of cachedAllowedTriggerTypes; track trigger) {
                    <nz-option [nzValue]="trigger.value"
                    [nzLabel]="trigger.label"></nz-option>
                  }
                </nz-select>
                @if (cachedTriggerDescriptions && cachedTriggerDescriptions.length > 0) {
                  <div class="mt-1 text-muted">
                    <small>
                      @for (description of cachedTriggerDescriptions; track description) {
                        <span>{{ description }} </span>
                      }
                    </small>
                  </div>
                }
              </nz-form-control>
            </nz-form-item>
          }

          <!-- Level 5: CRON Schedule Expression (Only visible when "Scheduled" trigger is selected) -->
          @if (shouldShowCronSchedule()) {
            <nz-form-item>
              <nz-form-label [nzSpan]="8" nzRequired>CRON Schedule Expression</nz-form-label>
              <nz-form-control [nzSpan]="14" [nzErrorTip]="cronErrorTpl">
                <input nz-input formControlName="CronScheduleExpression" name="CronScheduleExpression"
                  placeholder="Enter cron expression (e.g., 0 0 * * *)" />
                <ng-template #cronErrorTpl let-control>
                  @if (control.hasError('required')) {
                    Please input cron expression
                  }
                  @if (control.hasError('invalidCron')) {
                    Invalid cron expression
                  }
                </ng-template>
                <!-- Schedule Description -->
                @if (cronScheduleDescription) {
                  <div class="mt-2 text-success">
                    <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
                    {{ cronScheduleDescription }}
                  </div>
                }
              </nz-form-control>
            </nz-form-item>
          }

          @if (shouldShowCronSchedule()) {
            <nz-form-item>
              <nz-form-control [nzSpan]="12" [nzOffset]="7">
                <div class="text-muted">
                  <small>
                    Examples:<br>
                    "0 0 * * *" - Every day at midnight<br>
                    "0 0 * * MON" - Every Monday at midnight<br>
                    "0 */4 * * *" - Every 4 hours
                  </small>
                </div>
              </nz-form-control>
            </nz-form-item>
          }

          <!-- Level 6: User Type (Filtered based on configuration permissions) -->
          @if (SelectedConfiguration) {
            <nz-form-item>
              <nz-form-label [nzSpan]="8" nzRequired>User Type</nz-form-label>
              <nz-form-control [nzSpan]="14" nzValidateStatus="success">
                <nz-select formControlName="UserType" name="userType" nzShowSearch nzPlaceHolder="Select User Type"
                  (ngModelChange)="onUserTypeChange($event)">
                  @for (userType of cachedAllowedUserTypes; track userType) {
                    <nz-option [nzValue]="userType.value"
                    [nzLabel]="userType.label"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          }

          <!-- Show User List -->
          @if (showInternalUser) {
            <nz-form-item>
              <nz-form-label [nzSpan]="8" nzRequired>Users</nz-form-label>
              <nz-form-control [nzSpan]="14" nzValidateStatus="success">
                <nz-select name="select-error3" nzShowSearch formControlName="UserMasterId" nzPlaceHolder="Select User">
                  @for (s of UserList; track s) {
                    <nz-option [nzValue]="s.UserId" [nzLabel]="s.Name"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          }

          <!-- Show Customer List -->
          @if (showCustomerList) {
            <nz-form-item>
              <nz-form-label [nzSpan]="8" nzRequired>Customers</nz-form-label>
              <nz-form-control [nzSpan]="14" nzValidateStatus="success">
                <nz-select name="select-error3" nzShowSearch formControlName="UserMasterId"
                  nzPlaceHolder="Select Customer">
                  @for (s of CustomerList; track s) {
                    <nz-option [nzValue]="s.CustomerId"
                    [nzLabel]="s.CustomerName"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          }

          @if (isUserTypeExternal) {
            <nz-form-item>
              <nz-form-label [nzSpan]="8" nzRequired>Name</nz-form-label>
              <nz-form-control [nzSpan]="14">
                <input nz-input formControlName="Name" name="Name" />
              </nz-form-control>
            </nz-form-item>
          }

          @if (isUserTypeExternal) {
            <nz-form-item>
              <nz-form-label [nzSpan]="8" nzRequired>Email</nz-form-label>
              <nz-form-control [nzSpan]="14">
                <input nz-input formControlName="Email" name="Email" />
              </nz-form-control>
            </nz-form-item>
          }

          @if (isUserTypeExternal) {
            <nz-form-item>
              <nz-form-label [nzSpan]="8" nzRequired>Mobile Number</nz-form-label>
              <nz-form-control [nzSpan]="14" [nzErrorTip]="mobileNumberErrorTpl">
                <input nz-input formControlName="MobileNumber" name="MobileNumber"
                  placeholder="Mobile number (must start with 91 followed by 10 digits)" />
                <ng-template #mobileNumberErrorTpl let-control>
                  @if (control.hasError('invalidMobileNumber')) {
                    Mobile number must start with 91 followed by 10 digits (total 12 digits)
                  }
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          }

          <!-- Level 7: WhatsApp Notification (Toggle switch) -->
          @if (SelectedConfiguration) {
            <nz-form-item>
              <nz-form-label [nzSpan]="8">WhatsApp Notification</nz-form-label>
              <nz-form-control [nzSpan]="14">
                <nz-switch formControlName="IsWhatsAppNotificationEnabled" name="IsWhatsAppNotificationEnabled"
                  (ngModelChange)="setWhatsAppNotification($event)">
                </nz-switch>
                <div class="mt-1 text-muted">
                  <small><i nz-icon nzType="info-circle"></i> Template will be automatically selected based on
                configuration</small>
              </div>
            </nz-form-control>
          </nz-form-item>
        }

        <!-- Push Notification (Toggle switch) -->
        @if (SelectedConfiguration?.PushNotificationAllowed) {
          <nz-form-item>
            <nz-form-label [nzSpan]="8">Push Notification</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <nz-switch formControlName="IsPushNotificationEnabled" name="IsPushNotificationEnabled"
                (ngModelChange)="setPushNotification($event)">
              </nz-switch>
              <div class="mt-1 text-muted">
                <small><i nz-icon nzType="info-circle"></i> Send to KanzenFlow mobile app
              (requires user to have the app installed)</small>
            </div>
          </nz-form-control>
        </nz-form-item>
      }

      <!-- Level 8: Email Options (To Email, CC Email, BCC Email toggles) -->
      @if (SelectedConfiguration) {
        <nz-form-item>
          <nz-form-label [nzSpan]="8">Email Options</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <div class="email-options-group">
              <div class="email-option">
                <nz-switch formControlName="EnableToEmail" name="EnableToEmail"
                  (ngModelChange)="setEnableToEmail($event)">
                </nz-switch>
                <span class="ml-2">To Email</span>
              </div>
              <div class="email-option mt-2">
                <nz-switch formControlName="EnableCcemail" name="EnableCcemail"
                  (ngModelChange)="setEnableCcemail($event)">
                </nz-switch>
                <span class="ml-2">CC Email</span>
              </div>
              <div class="email-option mt-2">
                <nz-switch formControlName="EnableBccemail" name="EnableBccemail"
                  (ngModelChange)="setEnableBccemail($event)">
                </nz-switch>
                <span class="ml-2">BCC Email</span>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      }
    </form>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">
      Cancel
    </button>
    @if (permission.Add || permission.Edit) {
      <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isLoading"
        >
        Save Notification Group
      </button>
    }
  </ng-template>
</nz-modal>

<!-- View Drawer -->
<nz-drawer [nzVisible]="isViewDrawerVisible" [nzWidth]="750" [nzTitle]="viewDrawerTitle" [nzClosable]="true"
  (nzOnClose)="closeViewDrawer()">

  <ng-container *nzDrawerContent>
    <!-- Loading State -->
    @if (isLoadingDetails) {
      <div class="text-center p-4">
        <nz-spin nzSize="large">
          <div class="text-muted">Loading notification group details...</div>
        </nz-spin>
      </div>
    }

    <!-- Error State -->
    @if (!isLoadingDetails && !selectedNotificationGroupDetails && selectedNotificationGroup) {
      <div
        class="text-center p-4">
        <nz-result nzStatus="error" nzTitle="Failed to load details"
          nzSubTitle="Unable to fetch detailed information for this notification group.">
          <div nz-result-extra>
            <button nz-button nzType="primary"
              (click)="loadNotificationGroupDetails(selectedNotificationGroup.NotificationGroupUserId)">
              <i nz-icon nzType="reload" nzTheme="outline"></i>
              Retry
            </button>
          </div>
        </nz-result>
      </div>
    }

    <!-- Detailed Content -->
    @if (!isLoadingDetails && selectedNotificationGroupDetails) {
      <div class="notification-details">
        <!-- Basic Information -->
        <nz-card nzTitle="Basic Information" [nzSize]="'small'" class="mb-3">
          <div class="row">
            <div class="col-md-6">
              <p><strong>Notification Type:</strong> {{ selectedNotificationGroupDetails.NotificationType }}</p>
              <p><strong>User Type:</strong> {{ selectedNotificationGroupDetails.UserType }}</p>
              <p><strong>User Name:</strong> {{ selectedNotificationGroupDetails.Name || 'N/A' }}</p>
              <p><strong>Report Name:</strong> {{ selectedNotificationGroupDetails.ReportName || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <p><strong>Trigger Types:</strong></p>
              <div>
                @for (trigger of selectedNotificationGroupDetails.TriggerType; track trigger) {
                  <nz-tag
                    [nzColor]="getTriggerTypeColor(trigger)" style="margin-right: 4px;">
                    {{ trigger }}
                  </nz-tag>
                }
              </div>
              <p class="mt-2"><strong>Status:</strong>
              <nz-tag [nzColor]="selectedNotificationGroupDetails.Disabled ? 'red' : 'green'">
                {{ selectedNotificationGroupDetails.Disabled ? 'Disabled' : 'Active' }}
              </nz-tag>
            </p>
          </div>
        </div>
      </nz-card>
      <!-- Contact Information -->
      <nz-card nzTitle="Contact Information" [nzSize]="'small'" class="mb-3">
        <div class="row">
          <div class="col-md-6">
            <p><strong>Email:</strong> {{ selectedNotificationGroupDetails.Email || 'N/A' }}</p>
            <p><strong>Mobile Number:</strong> {{ selectedNotificationGroupDetails.MobileNumber || 'N/A' }}</p>
          </div>
          <div class="col-md-6">
            <p><strong>WhatsApp Enabled:</strong>
            <nz-tag [nzColor]="selectedNotificationGroupDetails.IsWhatsAppNotificationEnabled ? 'green' : 'red'">
              {{ selectedNotificationGroupDetails.IsWhatsAppNotificationEnabled ? 'Yes' : 'No' }}
            </nz-tag>
          </p>
          <p><strong>Push Notification:</strong>
          <nz-tag [nzColor]="selectedNotificationGroupDetails.IsPushNotificationEnabled ? 'green' : 'default'">
            {{ selectedNotificationGroupDetails.IsPushNotificationEnabled ? 'Enabled' : 'Disabled' }}
          </nz-tag>
        </p>
      </div>
    </div>
  </nz-card>
  <!-- WhatsApp Configuration -->
  @if (selectedNotificationGroupDetails.IsWhatsAppNotificationEnabled && selectedNotificationGroupDetails.WhatsAppTemplate) {
    <nz-card nzTitle="WhatsApp Configuration" [nzSize]="'small'" class="mb-3"
      >
      <div class="row">
        <div class="col-md-6">
          <p><strong>Template Name:</strong> {{
        selectedNotificationGroupDetails.WhatsAppTemplate.ProviderTemplateName || 'N/A' }}</p>
        <p><strong>Provider:</strong> {{ selectedNotificationGroupDetails.WhatsAppTemplate.ProviderName || 'N/A'
      }}</p>
      <p><strong>Template ID:</strong> {{ selectedNotificationGroupDetails.WhatsAppTemplate.ProviderTemplateId
    || 'N/A' }}</p>
  </div>
  <div class="col-md-6">
    <p><strong>Description:</strong> {{
  selectedNotificationGroupDetails.WhatsAppTemplate.ProviderTemplateDescription || 'N/A' }}</p>
  @if (selectedNotificationGroupDetails.WhatsAppConfig) {
    <div>
      <p><strong>Sender Number:</strong> {{
    selectedNotificationGroupDetails.WhatsAppConfig.RegisteredSenderNumber || 'N/A' }}</p>
  </div>
}
</div>
</div>
<!-- Template Parameters -->
@if (selectedNotificationGroupDetails.WhatsAppTemplate.Parameters && selectedNotificationGroupDetails.WhatsAppTemplate.Parameters.length > 0) {
  <div
    class="mt-3">
    <h6>Template Parameters:</h6>
    <nz-table #templateParamsTable [nzData]="selectedNotificationGroupDetails.WhatsAppTemplate.Parameters"
      [nzSize]="'small'" [nzShowPagination]="false">
      <thead>
        <tr>
          <th>Sequence</th>
          <th>Parameter Name</th>
          <th>Type</th>
          <th>Required</th>
          <th>Default Value</th>
        </tr>
      </thead>
      <tbody>
        @for (param of templateParamsTable.data; track param) {
          <tr>
            <td>{{ param.Sequence || 'N/A' }}</td>
            <td>{{ param.ParameterName }}</td>
            <td>{{ param.ParameterType || 'Text' }}</td>
            <td>
              <nz-tag [nzColor]="param.IsRequired ? 'red' : 'default'">
                {{ param.IsRequired ? 'Required' : 'Optional' }}
              </nz-tag>
            </td>
            <td>{{ param.DefaultValue || 'N/A' }}</td>
          </tr>
        }
      </tbody>
    </nz-table>
  </div>
}
</nz-card>
}
<!-- Email Configuration -->
<nz-card nzTitle="Email Configuration" [nzSize]="'small'" class="mb-3">
  <div class="row">
    <div class="col-md-4">
      <p><strong>To Email:</strong>
      <nz-tag [nzColor]="selectedNotificationGroupDetails.EnableToEmail ? 'green' : 'default'">
        {{ selectedNotificationGroupDetails.EnableToEmail ? 'Enabled' : 'Disabled' }}
      </nz-tag>
    </p>
  </div>
  <div class="col-md-4">
    <p><strong>CC Email:</strong>
    <nz-tag [nzColor]="selectedNotificationGroupDetails.EnableCcemail ? 'green' : 'default'">
      {{ selectedNotificationGroupDetails.EnableCcemail ? 'Enabled' : 'Disabled' }}
    </nz-tag>
  </p>
</div>
<div class="col-md-4">
  <p><strong>BCC Email:</strong>
  <nz-tag [nzColor]="selectedNotificationGroupDetails.EnableBccemail ? 'green' : 'default'">
    {{ selectedNotificationGroupDetails.EnableBccemail ? 'Enabled' : 'Disabled' }}
  </nz-tag>
</p>
</div>
</div>
<!-- Email Provider Details -->
@if (selectedNotificationGroupDetails.EmailConfig) {
  <div class="mt-3">
    <h6>Email Provider Configuration:</h6>
    <div class="row">
      <div class="col-md-6">
        <p><strong>Config Name:</strong> {{ selectedNotificationGroupDetails.EmailConfig.EmailConfigName ||
      'N/A' }}</p>
      <p><strong>SMTP Server:</strong> {{ selectedNotificationGroupDetails.EmailConfig.EmailConfigSmtp ||
    'N/A' }}</p>
  </div>
  <div class="col-md-6">
    <p><strong>From Email:</strong> {{ selectedNotificationGroupDetails.EmailConfig.EmailConfigFromEmailId
  || 'N/A' }}</p>
  <p><strong>Display Name:</strong> {{
selectedNotificationGroupDetails.EmailConfig.EmailConfigFromEmailDisplayName || 'N/A' }}</p>
</div>
</div>
</div>
}
</nz-card>
<!-- Email Group Mappings -->
@if (selectedNotificationGroupDetails.EmailGroupMappings && selectedNotificationGroupDetails.EmailGroupMappings.length > 0) {
  <nz-card nzTitle="Email Group Mappings" [nzSize]="'small'" class="mb-3"
    >
    <nz-table #emailGroupTable [nzData]="selectedNotificationGroupDetails.EmailGroupMappings" [nzSize]="'small'"
      [nzShowPagination]="false">
      <thead>
        <tr>
          <th>Stage Name</th>
          <th>Status</th>
          <th>Internal Only</th>
          <th>Customer Only</th>
          <th>Added By</th>
          <th>Added Date</th>
        </tr>
      </thead>
      <tbody>
        @for (mapping of emailGroupTable.data; track mapping) {
          <tr>
            <td>{{ mapping.StageName || 'N/A' }}</td>
            <td>
              <nz-tag [nzColor]="mapping.Enabled && !mapping.Disabled ? 'green' : 'red'">
                {{ mapping.Enabled && !mapping.Disabled ? 'Enabled' : 'Disabled' }}
              </nz-tag>
            </td>
            <td>
              <nz-tag [nzColor]="mapping.OnlyInternal ? 'blue' : 'default'">
                {{ mapping.OnlyInternal ? 'Yes' : 'No' }}
              </nz-tag>
            </td>
            <td>
              <nz-tag [nzColor]="mapping.OnlyCustomer ? 'orange' : 'default'">
                {{ mapping.OnlyCustomer ? 'Yes' : 'No' }}
              </nz-tag>
            </td>
            <td>{{ mapping.AddedBy || 'N/A' }}</td>
            <td>{{ mapping.AddedDate ? (mapping.AddedDate | date:'short') : 'N/A' }}</td>
          </tr>
        }
      </tbody>
    </nz-table>
  </nz-card>
}
<!-- Schedule Management Section -->
@if (selectedNotificationGroupDetails.NotificationReportScheduleMappings && selectedNotificationGroupDetails.NotificationReportScheduleMappings.length > 0) {
  <nz-card nzTitle="Schedule Management" [nzSize]="'small'" class="mb-3"
    >
    <div class="schedule-management-section">
      <div class="mb-3">
        <p class="text-muted">
          <i nz-icon nzType="info-circle" nzTheme="outline"></i>
          Manage individual schedules for this notification group. You can enable or disable specific schedules
          as needed.
        </p>
      </div>
      <!-- Schedule Summary Cards -->
      <div class="schedule-summary mb-3">
        <div class="row">
          <div class="col-md-4">
            <div class="summary-card text-center p-2"
              style="background-color: #f6ffed; border: 1px solid #b7eb8f; border-radius: 4px;">
              <div class="summary-number text-success">{{ getActiveSchedulesCount() }}</div>
              <div class="summary-label">Active Schedules</div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="summary-card text-center p-2"
              style="background-color: #fffbe6; border: 1px solid #ffe58f; border-radius: 4px;">
              <div class="summary-number text-warning">{{ getDisabledSchedulesCount() }}</div>
              <div class="summary-label">Disabled Schedules</div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="summary-card text-center p-2"
              style="background-color: #e6f7ff; border: 1px solid #91d5ff; border-radius: 4px;">
              <div class="summary-number text-info">{{ getTotalSchedulesCount() }}</div>
              <div class="summary-label">Total Schedules</div>
            </div>
          </div>
        </div>
      </div>
      <!-- Schedule Cards Layout -->
      <div class="schedule-cards">
        @for (schedule of selectedNotificationGroupDetails.NotificationReportScheduleMappings; track schedule) {
          <div class="schedule-card mb-3"
            style="border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px; background-color: #fafafa;">
            <!-- Schedule Header -->
            <div class="schedule-header d-flex justify-content-between align-items-center mb-2">
              <div class="schedule-title">
                <h6 class="mb-1" style="color: #262626; font-weight: 600;">
                  {{ schedule.ReportName || schedule.ReportType || 'N/A' }}
                </h6>
                <nz-tag [nzColor]="getScheduleStatusColor(schedule)" style="margin: 0;">
                  {{ getScheduleStatusText(schedule) }}
                </nz-tag>
              </div>
              <div class="schedule-toggle">
                <nz-switch [ngModel]="schedule.IsActive && !schedule.Disabled" [nzLoading]="schedule.isUpdating"
                  (ngModelChange)="toggleScheduleStatus(schedule, $event)" nzSize="small">
                </nz-switch>
              </div>
            </div>
            <!-- Schedule Details -->
            <div class="schedule-details">
              <div class="row">
                <div class="col-md-6">
                  <div class="detail-item mb-2">
                    <label class="detail-label">CRON Expression:</label>
                    <div class="detail-value">
                      <code class="cron-expression">{{ schedule.CronExpression || 'N/A' }}</code>
                    </div>
                    @if (schedule.CronExpression) {
                      <div class="cron-description">
                        <small class="text-muted">{{ getCronDescription(schedule.CronExpression) }}</small>
                      </div>
                    }
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="detail-item mb-2">
                    <label class="detail-label">Schedule Status:</label>
                    <div class="detail-value">
                      <span class="status-text">
                        {{ (schedule.IsActive && !schedule.Disabled) ? 'Enabled' : 'Disabled' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="detail-item">
                    <label class="detail-label">Last Run:</label>
                    <div class="detail-value">
                      @if (schedule.LastRunTime) {
                        <span>
                          {{ schedule.LastRunTime.toString()| DatetimeConverter }}
                        </span>
                      } @else {
                        <span class="text-muted">Never</span>
                      }
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="detail-item">
                    <label class="detail-label">Next Run:</label>
                    <div class="detail-value">
                      @if (schedule.NextRunTime) {
                        <span>
                          {{ schedule.NextRunTime.toString()| DatetimeConverter }}
                        </span>
                      } @else {
                        <span class="text-muted">Not scheduled</span>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </nz-card>
}
<!-- Audit Information -->
<nz-card nzTitle="Audit Information" [nzSize]="'small'" class="mb-3">
  <div class="row">
    <div class="col-md-6">
      <p><strong>Added By:</strong> {{ selectedNotificationGroupDetails.AddedBy || 'N/A' }}</p>
      <p><strong>Added Date:</strong> {{ selectedNotificationGroupDetails.AddedDate ?
    (selectedNotificationGroupDetails.AddedDate | date:'medium') : 'N/A' }}</p>
  </div>
  <div class="col-md-6">
    <p><strong>Last Triggered By:</strong> {{ selectedNotificationGroupDetails.LastTriggeredBy || 'N/A' }}
  </p>
  <p><strong>Last Triggered Date:</strong> {{ selectedNotificationGroupDetails.LastTriggeredDate ?
(selectedNotificationGroupDetails.LastTriggeredDate | date:'medium') : 'N/A' }}</p>
</div>
</div>
<!-- Disabled Information -->
@if (selectedNotificationGroupDetails.Disabled) {
  <div class="row mt-3">
    <div class="col-md-12">
      <div class="alert alert-warning">
        <h6><i nz-icon nzType="warning" nzTheme="outline"></i> Disabled Status</h6>
        <p><strong>Disabled By:</strong> {{ selectedNotificationGroupDetails.DisabledBy || 'N/A' }}</p>
        <p><strong>Disabled Date:</strong> {{ selectedNotificationGroupDetails.DisabledDate ?
      (selectedNotificationGroupDetails.DisabledDate | date:'medium') : 'N/A' }}</p>
    </div>
  </div>
</div>
}
</nz-card>
</div>
}
</ng-container>
</nz-drawer>

<!-- Broadcast Push Notification Modal -->
<nz-modal [(nzVisible)]="isBroadcastModalVisible" [nzStyle]="{ top: '20px' }" nzWidth="600px"
  [nzTitle]="broadcastModalTitle" [nzContent]="broadcastModalContent" [nzFooter]="broadcastModalFooter"
  (nzOnCancel)="closeBroadcastModal()">
  <ng-template #broadcastModalTitle>Send Push Notification</ng-template>
  <ng-template #broadcastModalContent>
    <div nz-form>
      <!-- User Selection -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Users</nz-form-label>
        <nz-form-control [nzSpan]="15">
          <nz-select nzMode="multiple" nzShowSearch nzPlaceHolder="Select users to notify"
            [(ngModel)]="broadcastRequest.UserMasterIds" [nzMaxTagCount]="3">
            @for (user of pushEnabledUsers; track user) {
              <nz-option [nzValue]="user.UserId"
              [nzLabel]="user.Name"></nz-option>
            }
          </nz-select>
          <div class="mt-1 text-muted">
            <small><i nz-icon nzType="info-circle"></i> Only users with registered mobile devices are shown</small>
          </div>
        </nz-form-control>
      </nz-form-item>

      <!-- Title -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Title</nz-form-label>
        <nz-form-control [nzSpan]="15">
          <input nz-input [(ngModel)]="broadcastRequest.Title" placeholder="Notification title" maxlength="100" />
        </nz-form-control>
      </nz-form-item>

      <!-- Body -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Message</nz-form-label>
        <nz-form-control [nzSpan]="15">
          <textarea nz-input [(ngModel)]="broadcastRequest.Body" placeholder="Notification message"
          [nzAutosize]="{ minRows: 3, maxRows: 6 }" maxlength="500"></textarea>
        </nz-form-control>
      </nz-form-item>

      <!-- Message Type -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Message Type</nz-form-label>
        <nz-form-control [nzSpan]="15">
          <nz-select [(ngModel)]="broadcastRequest.MessageType" nzPlaceHolder="Select message type">
            @for (type of messageTypeOptions; track type) {
              <nz-option [nzValue]="type.value"
              [nzLabel]="type.label"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <!-- Priority -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Priority</nz-form-label>
        <nz-form-control [nzSpan]="15">
          <nz-select [(ngModel)]="broadcastRequest.Priority" nzPlaceHolder="Select priority">
            @for (p of priorityOptions; track p) {
              <nz-option [nzValue]="p.value" [nzLabel]="p.label"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <!-- Requires Acknowledgement -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7">Acknowledgement</nz-form-label>
        <nz-form-control [nzSpan]="15">
          <nz-switch [(ngModel)]="broadcastRequest.RequiresAcknowledgement"></nz-switch>
          <span class="ml-2">Require user acknowledgement</span>
        </nz-form-control>
      </nz-form-item>

      <!-- Expiry Duration (only shown when acknowledgement is enabled) -->
      @if (broadcastRequest.RequiresAcknowledgement) {
        <nz-form-item>
          <nz-form-label [nzSpan]="7">Expiry Duration</nz-form-label>
          <nz-form-control [nzSpan]="15">
            <nz-input-number [(ngModel)]="broadcastRequest.ExpiryDurationHours"
              [nzMin]="1" [nzMax]="720" [nzStep]="1"
            nzPlaceHolder="e.g. 24" style="width: 100%"></nz-input-number>
            <div class="mt-1 text-muted">
              <small><i nz-icon nzType="info-circle"></i> Hours until acknowledgement expires. Leave empty for no
            expiry.</small>
          </div>
        </nz-form-control>
      </nz-form-item>
    }
  </div>
</ng-template>

<ng-template #broadcastModalFooter>
  <button nz-button nzType="default" (click)="closeBroadcastModal()">Cancel</button>
  <button nz-button nzType="primary" (click)="sendBroadcastNotification()" [nzLoading]="isSendingBroadcast">
    <i nz-icon nzType="send" nzTheme="outline"></i> Send Notification
  </button>
</ng-template>
</nz-modal>

</div>
</div>